import React, { useState, lazy } from 'react';
export function ProductPreview() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const images = [{
    url: 'https://cdn.magicpatterns.com/uploads/m1DbnChjtkPdvfkF4eu26g/Captura_de_pantalla_2026-05-30_135152.webp',
    caption: 'Estructura de aprendizaje: Los 6 pilares para pasar de la teoría a la práctica sin lagunas.',
    width: 800,
    height: 1000
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/dCmvcdQUUGw3yawF1XjLQA/Captura_de_pantalla_2026-05-30_135420.webp',
    caption: 'Protocolo de Sesiones: Qué evaluar y qué documentos elaborar desde la sesión 1 hasta el alta clínica.',
    width: 800,
    height: 1000
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/9FWRxqd2kjEf9LDjFtpRWq/Captura_de_pantalla_2026-05-30_135542.webp',
    caption: 'Posicionamiento: Guía estratégica para elegir tu nicho y convertirte en un referente de tu especialidad.',
    width: 800,
    height: 1000
  }, {
    url: 'https://cdn.magicpatterns.com/uploads/saTwaxKnezfmdezCcjv1ra/Captura_de_pantalla_2026-05-30_135823.webp',
    caption: 'Gestión Real: Guía de impuestos y gastos deducibles para no cometer errores legales en tu primer año.',
    width: 800,
    height: 1000
  }];
  const nextSlide = () => {
    setCurrentIndex(prev => (prev + 1) % images.length);
  };
  const prevSlide = () => {
    setCurrentIndex(prev => (prev - 1 + images.length) % images.length);
  };
  const goToSlide = (index: number) => {
    setCurrentIndex(index);
  };
  return <section className="bg-brand-primary py-12 px-4" data-id="element-194">
      <div className="max-w-6xl mx-auto" data-id="element-195">
        {/* Label */}
        <div className="text-center mb-3" data-id="element-196">
          <span className="text-brand-accent font-body font-bold text-sm tracking-wider" data-id="element-197">
            📖 VISTA PREVIA
          </span>
        </div>

        {/* Heading */}
        <h2 className="font-display text-3xl md:text-4xl font-bold text-center mb-3 text-white" data-id="element-198">
          Mira el material por dentro
        </h2>

        {/* Subtitle */}
        <p className="font-body text-center text-white/80 mb-8 max-w-3xl mx-auto" data-id="element-199">
          Imágenes reales del sistema: sin simulaciones, contenido 100% práctico
          y profesional
        </p>

        {/* Carousel */}
        <div className="relative max-w-4xl mx-auto mb-8" data-id="element-200">
          {/* Main Image */}
          <div className="relative overflow-hidden rounded-lg" data-id="element-201">
            <img src={images[currentIndex].url} alt={`Vista previa ${currentIndex + 1}`} width={images[currentIndex].width} height={images[currentIndex].height} className="w-full h-auto border-4 border-white shadow-[0_0_30px_rgba(197,160,89,0.3)]" loading="lazy" decoding="async" data-id="element-202" />
          </div>

          {/* Navigation Arrows - Increased touch target size */}
          <button onClick={prevSlide} className="absolute left-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-brand-primary rounded-full p-4 shadow-lg transition-all min-w-[48px] min-h-[48px] flex items-center justify-center" aria-label="Anterior" data-id="element-203">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-204">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" data-id="element-205" />
            </svg>
          </button>

          <button onClick={nextSlide} className="absolute right-2 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-brand-primary rounded-full p-4 shadow-lg transition-all min-w-[48px] min-h-[48px] flex items-center justify-center" aria-label="Siguiente" data-id="element-206">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-207">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" data-id="element-208" />
            </svg>
          </button>

          {/* Caption */}
          <div className="mt-4 text-center" data-id="element-209">
            <p className="font-body text-white text-sm md:text-base italic px-4" data-id="element-210">
              {images[currentIndex].caption}
            </p>
          </div>

          {/* Dots Indicator - Increased touch target size */}
          <div className="flex justify-center gap-3 mt-6" data-id="element-211">
            {images.map((_, index) => <button key={index} onClick={() => goToSlide(index)} className={`rounded-full transition-all min-w-[44px] min-h-[44px] flex items-center justify-center ${index === currentIndex ? 'bg-brand-accent' : 'bg-white/40 hover:bg-white/60'}`} aria-label={`Ir a imagen ${index + 1}`} data-id="element-212">
                <span className={`w-3 h-3 rounded-full ${index === currentIndex ? 'bg-brand-accent' : 'bg-transparent'}`} data-id="element-213" />
              </button>)}
          </div>
        </div>

        {/* Closing Text */}
        <div className="bg-white/5 border border-white/10 rounded-lg p-6 md:p-8 max-w-3xl mx-auto text-center" data-id="element-214">
          <h3 className="font-display text-2xl font-bold text-brand-accent mb-3" data-id="element-215">
            Más de 200 páginas de rigor clínico y estratégico
          </h3>
          <p className="font-body text-white/90 leading-relaxed" data-id="element-216">
            Cada tomo ha sido diseñado con una estética limpia para facilitar tu
            lectura y consulta rápida entre sesiones. Recíbelo en formato PDF de
            alta resolución, listo para imprimir en A4 o usarlo en tu tablet
            dentro de la consulta.
          </p>
        </div>
      </div>
    </section>;
}